import pinia from "../core/pinia";
import { useVdpTableStore } from "../stores";
import type { ILoadedData, IRawSurfacesData } from "../types/table.types";


export default function loadDatasets(data: ILoadedData[], surfacesData: IRawSurfacesData) {
  const vdpTableStore = useVdpTableStore(pinia);
  vdpTableStore.setLoadedData(data);
  vdpTableStore.setLoadedSurfacesData(surfacesData);
}